<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <h2 class="text-center mb-4">Crear Evento</h2>

        <form @submit.prevent="guardarProyectoEvento">
          <!-- Listar en desplegable los eventos -->
          <div class="form-group mb-3">
            <label for="evento_cultivo_id">Evento:</label>
            <select v-model="selectedEventId" class="form-control" id="evento_cultivo_id" required>
              <option v-for="evento in eventos" :key="evento.id" :value="evento.id">
                {{ evento.nombre_evento }}
              </option>
            </select>

            <!-- Mostrar descripción evento seleccionado -->
            <p v-if="selectedEventId" class="mt-2">
              <strong>Descripción:</strong> {{ getSelectedEventDescription() }}
            </p>
          </div>

          <!-- Campos de Fecha -->
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="fecha_inicio" class="form-label">Fecha de Inicio:</label>
              <input 
                type="datetime-local" 
                v-model="fecha_inicio" 
                class="form-control" 
                id="fecha_inicio" 
                @change="calcularDias"
                required
              />
            </div>
            <div class="col-md-6">
              <label for="fecha_fin" class="form-label">Fecha de Fin:</label>
              <input 
                type="datetime-local" 
                v-model="fecha_fin" 
                class="form-control" 
                id="fecha_fin" 
                :min="fecha_inicio"
                @change="calcularDias"
                required
              />
            </div>
          </div>

          <!-- Campo Cantidad de Días -->
          <div class="form-group mb-3">
            <label for="dias">Cantidad de Días:</label>
            <div class="input-group">
              <input 
                v-model.number="cantidad_dias" 
                type="number" 
                class="form-control" 
                id="dias" 
                placeholder="Ingresa días" 
                @input="calcularFechaFin"
                min="1"
              />
              <span class="input-group-text">días</span>
            </div>
          </div>

          <!-- Mostrar duración -->
          <div class="mb-3">
            <p>Duración Calculada: <strong>{{ cantidad_dias }}</strong> días</p>
          </div>

          <!-- Campo Costo Estimado -->
          <div class="form-group mb-3">
            <label for="costoEstimado">Costo Estimado:</label>
            <input 
              type="number" 
              v-model="costoEstimado" 
              class="form-control" 
              id="costoEstimado" 
              placeholder="Ingresa el costo estimado"
            />
          </div>

          <!-- Botón para guardar el proyecto evento -->
          <button type="submit" class="btn btn-primary btn-block">Guardar Proyecto Evento</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  data() {
    return {
      fecha_inicio: this.obtenerFechaActual(), // Fecha actual por defecto
      fecha_fin: "",
      costoEstimado: null,
      cantidad_dias: 0,
      eventos: [],
      selectedEventId: null,
    };
  },
  props: {
    proyecto_id: {
      type: Number,
      required: true,
    },
  },
  methods: {
    getEventos() {
      axios
        .get("/api/eventos")
        .then((response) => {
          this.eventos = response.data;
        })
        .catch((error) => {
          console.error("Error al obtener los eventos", error);
        });
    },
    guardarProyectoEvento() {
      const datosDelProyectoEvento = {
        fecha_inicio: this.fecha_inicio,
        fecha_fin: this.fecha_fin,
        costoEstimado: this.costoEstimado,
        evento_cultivo_id: this.selectedEventId,
        proyecto_id: this.proyecto_id,
      };

      axios.post("/api/asociarProyectoEvento", datosDelProyectoEvento)
          .then(({ data: eventoCreado }) => {
            alert("Evento creado exitosamente");
            // Emitimos hacia el padre el objeto recién creado
            this.$emit("eventoCreado", eventoCreado);
          })
          .catch((error) => {
            console.error("Error al crear Proyecto Evento:", error);
          });

    },
    getSelectedEventDescription() {
      const selectedEvent = this.eventos.find(
        (evento) => evento.id === this.selectedEventId
      );
      return selectedEvent ? selectedEvent.descripcion : "";
    },
    calcularDias() {
      if (this.fecha_inicio && this.fecha_fin) {
        const inicio = new Date(this.fecha_inicio);
        const fin = new Date(this.fecha_fin);
        this.cantidad_dias = Math.max(
          Math.ceil((fin - inicio) / (1000 * 60 * 60 * 24)),
          0
        );
      }
    },
    calcularFechaFin() {
      if (this.fecha_inicio && this.cantidad_dias > 0) {
        const inicio = new Date(this.fecha_inicio);
        const nuevaFechaFin = new Date(
          inicio.setDate(inicio.getDate() + this.cantidad_dias)
        );
        this.fecha_fin =
          nuevaFechaFin.toISOString().split("T")[0] + "T00:00:00";
      }
    },
    obtenerFechaActual() {
      const ahora = new Date();
      return ahora.toISOString().slice(0, 16); // Retorna fecha y hora en formato 'YYYY-MM-DDTHH:mm'
    },
  },
  created() {
    this.getEventos();
  },
};
</script>

<style scoped>
.container {
  max-width: 600px;
  margin: auto;
}

h2 {
  color: #343a40;
}

.form-label {
  font-weight: bold;
}

.form-control {
  border: 1px solid #ced4da;
  border-radius: 5px;
}

.btn-primary {
  background-color: var(--app-primary);
  border-color: var(--app-primary);
}

.btn-primary:hover {
  background-color: var(--app-primary);
  border-color: #004085;
}
</style>
